"use client";

import React from "react";
import { ArrowRight, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function PivotDoorGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="127695" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-6">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-[500px] animate-pulse rounded-none bg-muted/50 border border-border" />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <AlertCircle className="mb-4 h-12 w-12 text-destructive" />
        <p className="text-lg text-foreground">{error}</p>
      </div>;
  }
  if (products.length === 0) {
    return <div className="py-12 text-center">
        <p className="text-lg text-muted-foreground">
          No watch models currently available in the collection.
        </p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-6">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group relative flex flex-col overflow-hidden rounded-none border border-border bg-card transition-all duration-[600ms] ease-out hover:shadow-sm">
          {}
          <div className="relative aspect-[3/4] w-full overflow-hidden bg-[#E5E5E5]">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-105" /> : <div className="flex h-full w-full items-center justify-center bg-muted/20">
                <span className="font-sans text-xs text-muted-foreground uppercase tracking-wider">
                  Image Pending
                </span>
              </div>}

            {}
            {product.price !== undefined && <div className="absolute top-4 right-4 rounded-none bg-background/90 px-3 py-1 border border-border">
                <span className="font-sans text-xs font-bold text-foreground">
                  ${product.price.toFixed(2)}
                </span>
              </div>}
          </div>

          {}
          <div className="flex flex-grow flex-col p-6">
            <h3 className="mb-2 font-sans text-xl font-medium text-foreground">
              {product.title}
            </h3>

            {}
            <div className="mb-6">
              <span className="inline-block rounded-sm bg-muted px-2 py-1 font-sans text-[10px] font-bold text-secondary uppercase tracking-widest">
                50 PCS MOQ
              </span>
            </div>

            {}
            {product.short_description && <div className="mb-6 line-clamp-2 text-sm text-secondary [&_p]:mb-0" dangerouslySetInnerHTML={{
          __html: product.short_description
        }} />}

            {}
            <div className="mt-auto flex flex-col gap-3 sm:flex-row">
              <Button variant="ghost" asChild className="flex-1 border border-foreground text-foreground rounded-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-foreground hover:text-background">
                <Link to={product.link}>
                  View Specs <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>

              <div className="flex-1">
                <AddToCartButton productId={product.id} variant="default" className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary-600 transition-colors rounded-none font-sans uppercase text-xs tracking-widest" text="Order Sample" showQuantity={false} />
              </div>
            </div>
          </div>
        </div>)}
    </div>;
}
export default function PivotDoorProductGrid() {
  const wp_query_params = {
    per_page: 6
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="featured-watch-collection" className="bg-background py-24 px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-left">
          <h2 className="mb-4 font-sans text-4xl font-medium tracking-tight text-foreground md:text-5xl">
            Available Watch Models for Customization
          </h2>
          <p className="max-w-2xl font-sans text-lg text-secondary">
            Start from proven designs — reduce risk and cost.
          </p>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 6
      }}>
          <PivotDoorGridConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}